// extracted by mini-css-extract-plugin
module.exports = {"header":"FakeHeader_header__PCt9T","search":"FakeHeader_search__wVSbp","link":"FakeHeader_link__mP4Ki"};